import { History } from "lucide-react";
import { Carte, COL, Indisponible, Vide, dateFr, isErreur, nombre } from "./shared";

const CYCLES = { campagne: "Campagne", cycle: "Cycle", fond: "Fumure de fond", entretien: "Entretien" };

export default function HistoriqueCard({ data }) {
  return (
    <Carte titre="Historique" numero="8" icon={History} testId="fiche-historique">
      {isErreur(data) ? <Indisponible /> : data.length ? (
        <ul className="divide-y" style={{ borderColor: COL.line }}>
          {data.map((h) => (
            <li key={h.fiche_id} className="py-2">
              <div className="flex justify-between gap-2 text-sm">
                <span className="font-semibold">{h.culture || CYCLES[h.type_cycle] || "Cycle"}</span>
                <span className="shrink-0">{h.rendement_t_ha != null ? `${nombre(h.rendement_t_ha)} t/ha` : "—"}</span>
              </div>
              <div className="text-xs text-gray-500">
                {[h.ilot_nom, `${dateFr(h.date_debut)} → ${dateFr(h.date_fin) || "…"}`, "fiche ferti clôturée"].join(" · ")}
              </div>
            </li>
          ))}
        </ul>
      ) : <Vide>Aucune campagne clôturée.</Vide>}
    </Carte>
  );
}
